import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription, tap } from 'rxjs';
import { JobsService } from 'src/app/core/services/jobs.service';

interface ReorderJobList {
  id: string;
  slurmId: number;
  jobName: number;
  jobNumber: number;
  submittedOn: Date;
}

@Component({
  selector: 'app-reorder-queued-jobs',
  templateUrl: './reorder-queued-jobs.component.html',
  styleUrls: ['./reorder-queued-jobs.component.scss'],
})
export class ReorderQueuedJobsComponent implements OnInit {
  constructor(
    public dialog: MatDialogRef<ReorderQueuedJobsComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      depName: string;
    },
    private jobService: JobsService,
    private spinner: NgxSpinnerService,
    private snackBar: MatSnackBar
  ) {}
  jobList: ReorderJobList[] = null;
  ogJobList: ReorderJobList[] = null;
  fetchQueued$: Subscription;
  isSubmitting: boolean = true;
  errorMessage: string = null;

  ngOnInit(): void {
    this.spinner.show('queuedJobs');
    this.fetchQueued$ = this.jobService
      .getQueuedJobSequenceForUser(this.data.depName)
      .pipe(tap(() => this.spinner.hide('queuedJobs')))
      .subscribe({
        next: (data: any) => {
          this.jobList = JSON.parse(JSON.stringify(data));
          this.ogJobList = JSON.parse(JSON.stringify(data));
          if (data?.length == 0) {
            this.errorMessage = 'No queued jobs found';
            this.isSubmitting = true;
          } else {
            this.isSubmitting = false;
          }
        },
        error: (error) => {
          this.spinner.hide('queuedJobs');
          this.errorMessage =
            error?.error?.message || 'Error fetching queued jobs';
        },
      });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.fetchQueued$?.unsubscribe();
  }

  onCancel() {
    this.dialog.close(false);
  }

  onSubmit() {
    if (this.jobList.length == 0 || this.jobList == null) {
      this.snackBar.open('No jobs to update', 'Close', { duration: 3000 });
      this.dialog.close(false);
      return;
    }
    if (JSON.stringify(this.jobList) == JSON.stringify(this.ogJobList)) {
      this.dialog.close(false);
      return;
    }
    this.spinner.show('queuedJobs');
    this.isSubmitting = true;
    let jobIds = this.jobList.map((job) => job.slurmId);
    this.jobService
      .setQueuedJobSequenceForUser(this.data.depName, jobIds.toString())
      .pipe(tap(() => this.spinner.hide('queuedJobs')))
      .subscribe({
        next: (data: any) => {
          this.snackBar.open(data?.actionMessage, 'Close', { duration: 3000 });
          this.dialog.close(true);
        },
        error: (error) => {
          this.spinner.hide('queuedJobs');
          this.snackBar.open(
            error?.error?.message || 'Error updating sequence',
            'Close',
            { duration: 3000 }
          );
          this.isSubmitting = false;
        },
      });
  }
  
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.jobList, event.previousIndex, event.currentIndex);
  }
}
